<template>
  <section class="resumen-reserva">
    <hr/>
    <h5 v-text="idioma.resumen.resumen"></h5>

    <br>
    <article class="resumen mb-5">
      <table class="table table-responsive-sm table-bordered table-resumen col-12">
        <thead>
        <tr>
          <th class="text-center destacado" colspan="4">
            <h3 class="titulo">Datos Personales</h3>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td><strong>{{idioma.personales.nombre}} </strong></td>
          <td class="text-center">{{ `${getCustomer().name} ${getCustomer().surname}` }}</td>
          <td><strong>{{ idioma.personales.correoe }} </strong></td>
          <td class="text-center">{{ `${getCustomer().email}` }}</td>
        </tr>
        <tr>
          <td><strong>{{ idioma.personales.tfno }} </strong></td>
          <td class="text-center">{{ `${getCustomer().phone}` }}</td>
          <td><strong>{{ idioma.personales.pais }} </strong></td>
          <td class="text-center">{{ `${getCustomer().country}` }}</td>
        </tr>
        <tr>
          <td><strong> {{ idioma.personales.provincia }} </strong></td>
          <td class="text-center">{{ `${getCustomer().state}` }}</td>
          <td><strong>{{ idioma.personales.poblacion }}</strong></td>
          <td class="text-center">{{ `${getCustomer().city}` }}</td>
        </tr>
        <tr>
          <td><strong>{{ idioma.personales.direccion }}</strong></td>
          <td class="text-center">{{ `${getCustomer().street}` }}</td>
          <td><strong>{{ idioma.personales.cp }}</strong></td>
          <td class="text-center">{{ `${getCustomer().postcode}` }}</td>
        </tr>
        </tbody>
      </table>
    </article>
    <article class="resumen">
      <table class="table table-responsive-sm table-bordered table-resumen col-12" v-for="(ele, idx) in refugios"
             v-if="ele.name">
        <thead>
        <tr>
          <th class="text-center destacado" colspan="4"><h3 class="titulo">{{ ele.name }}
            <small>({{ ele.roomName }})</small></h3></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td><strong>{{ idioma.resumen.entrada }}</strong></td>
          <td>{{ ele.humanCheckIn }}</td>
          <td><strong>{{ idioma.resumen.salida }}</strong></td>
          <td>{{ ele.humanCheckOut }}</td>
        </tr>
        <tr>
          <td><strong>Número de noches</strong></td>
          <td>{{ ele.nigths }}</td>
          <td><strong>Número de plazas</strong></td>
          <td>{{ ele.persons }}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-center">
            <strong>{{ idioma.resumen.distintos }}</strong>
          </td>
        </tr>
        <tr v-for="(v, k, idd) in servicios[ele.booking]">
          <td>
            <strong>
              {{ k | dateToEs }}
            </strong>
          </td>
          <td colspan="3">
            {{ servicesString(idx, v) }}
          </td>
        </tr>
        </tbody>
      </table>
    </article>
    <strong>{{ idioma.total }}</strong> <span v-if="payment">{{ getAdelanto }} € </span>&nbsp;
    <div class="infoBtn infoBtnContinuo" data-toggle="modal" data-target="#infoAdelanto">
      <i class="fa icon-info info"></i>
    </div>
    <p v-if="inTime">{{ idioma.resumen.tiempoRestante }} {{ this.minutes }}:{{ this.seconds }}</p>
    <p v-if="!inTime">{{ idioma.resumen.tiempoFin }}</p>


    <form :action="payment.urlEnt" method="POST" ref="pagoTPV">
      <input type="hidden" name="Ds_MerchantParameters" :value="payment.params">
      <input type="hidden" name="Ds_Signature" :value="payment.signature">
      <input type="hidden" name="Ds_SignatureVersion" :value="payment.version">
      <!--<button type="reset" class="cancelar" @click="cancelar">{{idioma.CancelarBtn}}</button>-->
      <button type="reset" class="cancelar" data-toggle="modal" data-target="#cancelar">{{ idioma.resumen.CancelarBtn }}
      </button>
      <button v-if="inTime" class="floatRight" type="button" @click="test">{{ idioma.resumen.AceptarBtn }}</button>
    </form>
    <ModalsController :idioma="idioma.resumen" modal="infoAdelanto"></ModalsController>
    <ModalsController :idioma="idioma.resumen" @cancelar="cancelar" modal="cancelar"/>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { refugeService } from '../../_services'
import { refugesHelper } from '../../_helpers'
import moment from 'moment'
import ModalsController from '../modals/ModalsController'

export default {
  name: 'BookingConfirmation',
  components: { ModalsController },
  props: ['idioma'],
  data () {
    return {
      refugios: [],
      servicios: [],
      payment: {
        urlEnt: '',
        params: '',
        signature: '',
        version: ''
      },
      minutes: 0,
      seconds: 0,
      secDuration: 180,
      inTime: true,
      total: 0
    }
  },
  created () {
    this.refugios = this.getBooking().items
    this.servicios = this.getJoinServices() //this.getBooking().services
    refugeService.getBookingPayment().then(data => this.payment = data.result)
    refugeService.getExpirationTime().then(data => {
      if (data.response) this.secDuration = data.result
      this.countdown()
    }).catch(err => {
      console.log(err)
      this.secDuration = 90
      this.countdown()
    })
  },
  filters: {
    dateToEs (_date) {
      return _date.split('-').reverse().join('/')
    }
  },
  computed: {
    getAdelanto () {
      return this.payment.adelanto || 0
    }
  },
  methods: {
    ...mapGetters(['getBooking', 'getJoinServices', 'getCustomer']),
    servicesString (ref, svs) {
      let ret = []
      svs.forEach(id => {
        if (this.refugios[ref].services[id])
          ret.push(this.refugios[ref].services[id].nombre)
        else
          ret.push(this.refugios[ref].otherServices[id].nombre)
      })
      if (ret.length === 0)
        ret.push('-')
      return ret.join(', ')
    },
    cancelar () {
      this.$emit('cancelBooking')
    },
    countdown () {
      let duration = moment.duration({
        'seconds': this.secDuration
      })
      let timer = setInterval(() => {
        duration = moment.duration(duration.asSeconds() - 1, 'seconds')
        this.minutes = duration.minutes()
        this.seconds = duration.seconds()
        if (this.minutes < 0) return clearInterval(timer)
        if (this.minutes < 10 && this.minutes.length != 2) this.minutes = '0' + this.minutes
        if (this.seconds < 0 && this.minutes != 0) {
          this.minutes -= 1
          this.seconds = 59
        } else if (this.seconds < 10 && this.seconds.length != 2) this.seconds = '0' + this.seconds
        if (this.minutes == 0 && this.seconds == 0) {
          clearInterval(timer)
          this.inTime = false
        }

      }, 1000)
    },
    test () {
      // Notificar a la API que se va al TPV
      refugeService.notifyPayment(refugesHelper.prepareToSend({ idioma: 'es' }, 'idioma')).then(data => {
        if (data.response)
          this.$refs.pagoTPV.submit()
      })
    }
  }
}
</script>

<style scoped>
table.table-resumen {
  border-width: 0;
}

table.table-resumen tbody {
  border-style: solid;
  border-color: #05bdbd;
  border-width: 1px 0 0 1px;
}

table.table-resumen td {
  border-color: #05bdbd;
  border-width: 0 1px 1px 0;
}

.destacado {
  background-color: #05bdbd;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BookingConfirmation.vue